import { AchRecipientFilterModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { defaultAchRecipientActivityFilterDto } from './data/ach.data';

export class AchRecipientActivityFilter extends DomainEntity<AchRecipientFilterModelDto> {
    constructor(protected dto = defaultAchRecipientActivityFilterDto) {
        super(dto);
    }

    public createDefault(): this {
        return new AchRecipientActivityFilter() as this;
    }

    public get recordType() {
        return this.dto.recordType || 'Both';
    }

    public set recordType(recordType) {
        this.dto.recordType = recordType;
    }

    public get recipientName() {
        return this.dto.recipientName || '';
    }

    public set recipientName(recipientName) {
        this.dto.recipientName = recipientName;
    }

    public get amountType() {
        return this.dto.amountType;
    }

    public set amountType(amountType) {
        this.dto.amountType = amountType;
    }

    public get amount() {
        return this.dto.amount;
    }

    public set amount(amount) {
        this.dto.amount = amount;
    }

    public get amountMin() {
        return this.dto.amountMin;
    }

    public set amountMin(amountMin) {
        this.dto.amountMin = amountMin;
    }

    public get amountMax() {
        return this.dto.amountMax;
    }

    public set amountMax(amountMax) {
        this.dto.amountMax = amountMax;
    }

    public get prenote() {
        return this.dto.prenote ?? false;
    }

    public set prenote(prenote) {
        this.dto.prenote = prenote;
    }

    public get hold() {
        return this.dto.hold ?? false;
    }

    public set hold(hold) {
        this.dto.hold = hold;
    }

    public get reversal() {
        return this.dto.reversal ?? false;
    }

    public set reversal(reversal) {
        this.dto.reversal = reversal;
    }
}
